<template>
  <div class="d-flex justify-content-end">
    <span class="d-flex">{{ $moment(value).format('yyyy/MM/DD HH:mm:ss') }}</span>
  </div>
</template>

<script>
export default {
  name: "Dating",
  props: {
    value: {
      type: [String, null],
      required: true
    }
  },
  inject: [
    '$moment'
  ],
}
</script>
